<template>
  <div>
    <div
      class="floating_assistant_button"
      @click="toggleDrawer"
      :title="isOpen ? 'Close Assistant' : 'Open Assistant'"
    >
      <ThemeImage
        v-if="!isOpen"
        :icon="imageNames.AGI_ASSISTANT_LIGHTNING"
        alt="assistant"
        class="size-5"
      />
      <ThemeImage
        v-else
        :icon="imageNames.CLOSE_GREY"
        alt="close"
        class="size-5"
      />
    </div>

    <FloatingAssistantDrawer
      v-model="isOpen"
    />
  </div>
</template>

<script setup>
import { ref } from "vue";
import ThemeImage from "@/src/components/ThemeImage.vue";
import FloatingAssistantDrawer from "./FloatingAssistantDrawer.vue";
import { imageNames } from "@/src/constants/imageConstants.js";

const isOpen = ref(false);

const toggleDrawer = () => {
  isOpen.value = !isOpen.value;
};
</script>

<style scoped>
.floating_assistant_button {
  position: fixed;
  right: -5px;
  top: 50%;
  transform: translateY(-50%);
  width: 45px;
  height: 45px;
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
  background: var(--background-color);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
  transition: all 0.3s ease;
  z-index: 999;
}

.floating_assistant_button:hover {
  transform: translateY(-50%) scale(1.1);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.6);
}

.floating_assistant_button:active {
  transform: translateY(-50%) scale(0.95);
}
</style>

